import { axios } from 'common/utils'
import { RecommendReviewParam } from 'common/types/params'
import { RecommendReviewState } from 'common/types/entities/recommendReview'
import { CompositeItemList, CompositeItemState } from 'common/types/entities/list'
import { ListItem } from 'common/constants'
import { ArrayUtils } from '@shopping/common'

export const fetchRecommendReviews = async (params: RecommendReviewParam): Promise<RecommendReviewState> => {
  const result = await axios.get<RecommendReviewState>('/v1/recommend-reviews', {
    params,
  })
  return result && result.data
}

const initCompositeItemState = (page: number, type: ListItem, id): CompositeItemState => {
  return {
    id,
    type,
    groupKey: page,
    key: type + page + id,
    item: {},
  }
}

export const fetchRecommendReviewsByGrid = async (params: RecommendReviewParam): Promise<CompositeItemList> => {
  const { page, pageSize } = params

  const result = await fetchRecommendReviews(params)

  const compositeData: CompositeItemList = {
    items: [],
    param: {
      page,
      pageSize,
    },
    hasMore: result.hasMore,
    itemCount: result.itemCount,
  }

  const { reviews } = result

  if (ArrayUtils.isNotEmpty(reviews)) {
    const items = reviews.map(review => {
      return {
        ...initCompositeItemState(page, ListItem.RECOMMEND_REVIEW, review._id),
        item: review,
      } as CompositeItemState
    })

    compositeData.items = items
  }

  return compositeData
}
